import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=5724e9d8"
import script from "./Audits.vue?vue&type=script&lang=js"
export * from "./Audits.vue?vue&type=script&lang=js"
import style0 from "./Audits.vue?vue&type=style&index=0&id=5724e9d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports